export function getAll() {
  const productType = window.localStorage["productType"];

  let items = [];
  if (productType == 2) {
    items = [
      {
        value: 60,
        text: "小計折扣",
      },
      {
        value: 53,
        text: "小計加成",
      },
      {
        value: 61,
        text: "小計折讓",
      },
    ];
  } else {
    items = [
      {
        value: 36,
        text: "單項折扣",
      },
      {
        value: 60,
        text: "小計折扣",
      },
      {
        value: 64,
        text: "單項加成",
      },
      {
        value: 53,
        text: "小計加成",
      },
      {
        value: 70,
        text: "單項折讓",
      },
      {
        value: 61,
        text: "小計折讓",
      },
      {
        value: 73,
        text: "部分小計折扣",
      },
    ];
  }
  return items;
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
